import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic'

export const airbnb: GetCustomerCopyFunc = () => {
  return {
    countriesToHideWorkLifeServicesFor: ['United Kingdom', 'Ireland'],
  }
}
